import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { UnauthorizedError } from './api';
import { AuthProvider } from './auth';
import { theme } from './theme';

/**
 * Bất kỳ request nào trả 401 đều lật trạng thái đăng nhập về "chưa" — nhờ vậy phiên
 * hết hạn giữa lúc đang dùng sẽ đưa về màn đăng nhập, thay vì hiện một thông báo
 * lỗi đỏ mà người dùng không biết phải làm gì.
 */
const queryCache = new QueryCache({
  onError: (error) => {
    if (error instanceof UnauthorizedError) queryClient.setQueryData(['me'], null);
  },
});

const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      // Không thử lại khi 401: đó là câu trả lời dứt khoát, không phải lỗi tạm thời.
      retry: (count, error) => !(error instanceof UnauthorizedError) && count < 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Không tìm thấy #root');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        {/* AuthProvider nằm TRONG QueryClientProvider vì nó dùng useQuery, và
            NGOÀI BrowserRouter vì màn đăng nhập không thuộc router nào. */}
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
